import React from 'react';
import { Grid, Box, Typography, CircularProgress, Skeleton } from '@mui/material';
import { HotelOutlined, LoginOutlined, LogoutOutlined } from '@mui/icons-material';
import GridItem from '@/components/GridItem/index.js';
import { useDashboardStats } from '@/hooks/useDashboardStats';
import { useToastError } from '@/hooks/useToastError';
import { useTranslation } from 'react-i18next';

const DashboardStats = () => {
  const { data, loading, error } = useDashboardStats();
  const { t } = useTranslation();

  useToastError(error, t('dashboard.fetchError'));

  if (loading || error) {
    return (
      <>
        {[0, 1, 2].map(i => (
          <Grid key={i} size={4}>
            <GridItem>
              <Skeleton variant="rounded" width={24} height={24} />
              <Skeleton variant="rounded" width={56} height={20} />
              <Skeleton
                variant="rounded"
                width={40}
                height={12}
                sx={{ mb: '16px' }}
              />
            </GridItem>
          </Grid>
        ))}
      </>
    );
  }

  return (
    <>
      <Grid size={4}>
        <GridItem>
          <LoginOutlined />
          <Typography variant="h6">
            {data?.saapuneet}
            {' '}
            /
            {' '}
            {data?.alkavat}
          </Typography>
          <Typography variant="caption">
            {t('dashboard.checkIn')}
          </Typography>
        </GridItem>
      </Grid>
      <Grid size={4}>
        <GridItem>
          <LogoutOutlined />
          <Typography variant="h6">
            {data?.lahteneet}
            {' '}
            /
            {' '}
            {data?.loppuvat}
          </Typography>
          <Typography variant="caption">
            {t('dashboard.checkOut')}
          </Typography>
        </GridItem>
      </Grid>
      <Grid size={4}>
        <GridItem>
          <HotelOutlined />
          <Typography variant="h6">
            {data?.jatkuvat}
          </Typography>
          <Typography variant="caption">
            {t('dashboard.ongoing')}
          </Typography>
        </GridItem>
      </Grid>
    </>
  );
};

export default DashboardStats;
